import { SITE_CONFIG } from "../app/config";
import { LegalLayout } from "./LegalLayout";

export const TermsPage = (): JSX.Element => (
  <LegalLayout title="Terms of Service" path="/terms">
    <section>
      <h2>1. Acceptance of Terms</h2>
      <p>
        By accessing and using {SITE_CONFIG.name} (the "Service"), you accept and agree to be bound 
        by these Terms of Service. If you do not agree to these terms, please do not use our Service.
      </p>
    </section>

    <section>
      <h2>2. Description of Service</h2>
      <p>
        {SITE_CONFIG.name} is a free tool that helps users discover where to purchase physical copies 
        (CDs and vinyl records) of music from their Spotify playlists. We provide links to third-party 
        retailers where users can purchase these items.
      </p>
    </section>

    <section>
      <h2>3. User Responsibilities</h2>
      <p>When using {SITE_CONFIG.name}, you agree to:</p>
      <ul>
        <li>Use the Service only for lawful purposes</li>
        <li>Not attempt to interfere with the proper functioning of the Service</li>
        <li>Not use automated systems or software to extract data from the Service</li>
        <li>Not misrepresent your identity or affiliation</li>
      </ul>
    </section>

    <section>
      <h2>4. Third-Party Links and Services</h2>
      <p>
        {SITE_CONFIG.name} contains links to third-party websites and services, including but not limited 
        to {SITE_CONFIG.affiliatePartner}, Spotify, and other retailers. We are not responsible for the 
        content, privacy policies, or practices of these third-party sites.
      </p>
      <p>
        When you click on affiliate links and make purchases, you are subject to the terms and conditions 
        of those third-party retailers. {SITE_CONFIG.name} is not a party to any transaction between you 
        and third-party retailers.
      </p>
    </section>

    <section>
      <h2>5. Spotify Disclaimer</h2>
      <p>
        {SITE_CONFIG.name} is not affiliated with, endorsed by, or sponsored by Spotify AB. Spotify is a 
        trademark of Spotify AB. We use Spotify's public API to retrieve playlist information with user consent.
      </p>
    </section>

    <section>
      <h2>6. Intellectual Property</h2>
      <p>
        The Service and its original content, features, and functionality are owned by {SITE_CONFIG.companyLegalName} 
        and are protected by international copyright, trademark, and other intellectual property laws.
      </p>
      <p>
        Album artwork, artist names, and other music-related content displayed on the Service are the property 
        of their respective owners.
      </p>
    </section>

    <section>
      <h2>7. Disclaimer of Warranties</h2>
      <p>
        The Service is provided "as is" and "as available" without warranties of any kind, either express or 
        implied. We do not guarantee that:
      </p>
      <ul>
        <li>The Service will be uninterrupted or error-free</li>
        <li>Product availability or pricing on third-party sites will be accurate</li>
        <li>All albums or formats will be available for purchase</li>
      </ul>
    </section>

    <section>
      <h2>8. Limitation of Liability</h2>
      <p>
        To the fullest extent permitted by law, {SITE_CONFIG.companyLegalName} shall not be liable for any 
        indirect, incidental, special, consequential, or punitive damages resulting from your use of 
        or inability to use the Service.
      </p>
    </section>

    <section>
      <h2>9. Changes to Terms</h2>
      <p>
        We reserve the right to modify these Terms at any time. We will notify users of significant changes 
        by updating the "Last updated" date. Continued use of the Service after changes constitutes acceptance 
        of the new Terms.
      </p>
    </section>

    <section>
      <h2>10. Governing Law</h2>
      <p>
        These Terms shall be governed by and construed in accordance with applicable laws, without regard 
        to conflict of law principles.
      </p>
    </section>

    <section>
      <h2>11. Contact</h2>
      <p>
        If you have questions about these Terms of Service, please contact us at{" "}
        <a href={`mailto:${SITE_CONFIG.contactEmail}`}>{SITE_CONFIG.contactEmail}</a>.
      </p>
    </section>
  </LegalLayout>
);

